// extracted by mini-css-extract-plugin
var _1 = "ra-text-columns";
var _2 = "ra-text-columns-section";
var _3 = "ra-text-columns-title";
export { _1 as "textColumnsCls", _2 as "textColumnsSectionCls", _3 as "textColumnsTitleCls" }
